export const CONNECTOR_MANAGER_PATH_NAME = 'connector-manager';

/**
 * The types of connectors, legacy, should be removed in the future.
 */
export const CONNECTOR_TYPES = [
  'webapp',
  'gitlab',
  'github',
  'generic',
] as const;

export type ConnectorType = (typeof CONNECTOR_TYPES)[number];

export const DEFAULT_CONNECTOR_TYPE: ConnectorType = 'generic';

export const TWINGATE_NETWORK_SLUG_MAX_LENGTH = 40;

export const TWINGATE_NETWORK_DISPLAY_NAME_MAX_LENGTH = 80;

export const TWINGATE_NETWORK_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
